module.exports = {
  text: `white`,
  "text-light": `hsl(217, 20%, 80%)`,
  "text-lighter": `hsl(217, 15%, 60%)`,

  background: `hsl(217, 0%, 15%)`,
  "background-light": `hsl(217, 0%, 10%)`
}